import {
  Alert,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Popconfirm,
  Radio,
  Row,
  Select,
  Space,
  Tooltip,
  Upload,
} from "antd";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { validateFileSize } from "../fileValidation";
import { upload_file } from "../../../services/uploads";
import {
  CopyOutlined,
  DeleteOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { useWatch } from "antd/es/form/Form";
import Title from "antd/es/typography/Title";

type Props = {
  form: any;
};

const EvaluationPage = (props: Props) => {
  const { t } = useTranslation();
  const [_, forceUpdate] = useState({});
  const [uploadingbase, setUploadingbase] = useState(false);
  const [uploadingsubmit, setUploadingsubmit] = useState(false);
  const [uploadingevaprivate, setUploadingevaprivate] = useState(false);
  const [uploadingevapub, setUploadingevapub] = useState(false);
  const [uploadingsheet, setUploadingsheet] = useState(false);
  const [uploadingpaper, setUploadingpaper] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasMetrics, setHasMetrics] = useState(false);
  const [mainMetricIndex, setMainMetricIndex] = useState<number | null>(null);
  const [tutorial, setTutorial] = useState({
    login: "",
    logout: "",
    image_pull: "",
    image_push: "",
    image_tag: "",
  });
  const [userData, setUser] = useState({
    user_name: "",
    user_code: "",
    org_name: "",
    user_email: "",
    profile_img: "",
    role_name: "",
  });

  const submission_type = useWatch("submissiontype", props.form);
  const submission_typedate = useWatch("submissiontypedate", props.form);
  const handleNumberInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const allowedKeys = /^[0-9]$/; // อนุญาตเฉพาะตัวเลข 0-9
    if (!allowedKeys.test(event.key)) {
      event.preventDefault();
    }
  };

  const handleTimeChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setValue: (value: string) => void,
  ) => {
    let value = e.target.value;
    value = value.replace(/[^0-9:]/g, "");
    const segments = value.split(":");
    if (segments.length > 3) return;
    if (/^([01]?\d|2[0-3])?(:([0-5]?\d)?)?(:([0-5]?\d)?)?$/.test(value)) {
      setValue(value);
    }
  };

  return (
    <div className="add-task-body-layout">
      <Alert
        style={{ marginTop: 20, marginBottom: 20 }}
        showIcon
        message={`${t("The file size must not exceed")} 300 MB`}
        type="info"
        closable
      />

      {/* baseline model */}
      <Row gutter={8} align="middle">
        <Col flex="auto">
          <Form.Item
            name="baseline_model"
            label="Baseline model"
            rules={[
              { required: false },
              { message: "Input name of event, please!" },
            ]}
          >
            <Input
              placeholder="Link"
              disabled={!!props.form.getFieldValue("baseline_model")} // ปิดการแก้ไข Input หากมีค่าใน baseline
            />
          </Form.Item>
        </Col>
        <Col>
          {props.form.getFieldValue("baseline_model") ? ( // ถ้ามีค่าใน baseline
            <Tooltip placement="bottom" title="Clear Path">
              <Button
                onClick={() => {
                  props.form.setFieldsValue({ baseline: null });
                  forceUpdate({}); // บังคับให้อัปเดตคอมโพเนนต์
                }}
                icon={"X"}
                danger
              ></Button>
            </Tooltip>
          ) : (
            <Tooltip placement="bottom" title="Upload">
              <Upload
                beforeUpload={(file) => validateFileSize(file, 300)}
                maxCount={1}
                showUploadList={false}
                onChange={async (info) => {
                  if (info.fileList.length > 0) {
                    const file = info.fileList[0].originFileObj;
                    const fileName = info.fileList[0].name;
                    try {
                      setUploadingbase(true);
                      const task_id = props.form.getFieldValue("task_id");
                      if (!task_id) {
                        message.error("Codename is not set");
                        return;
                      }

                      // อัปโหลดไฟล์ไปยัง API
                      const response = await upload_file({
                        task_id: task_id,
                        type: "baseline_model",
                        name: fileName,
                        file: file,
                      });

                      if (response.status === "success") {
                        // ตั้งค่าลิงก์ในฟิลด์ baseline
                        props.form.setFieldsValue({
                          baseline_model: response.link,
                        });
                        forceUpdate({}); // บังคับให้อัปเดตคอมโพเนนต์
                      } else {
                        console.error("File upload failed:", response);
                      }
                    } catch (error) {
                      console.error("Error uploading file:", error);
                    } finally {
                      setUploadingbase(false); // หยุดแสดง Loading เมื่อเสร็จสิ้น
                    }
                  }
                }}
              >
                <Button
                  style={{
                    backgroundColor: "#0E21A0",
                    color: "white",
                  }}
                  icon={!uploadingbase && <UploadOutlined />}
                  loading={uploadingbase}
                >
                  {uploadingbase ? "Uploading..." : ""}
                </Button>
              </Upload>
            </Tooltip>
          )}
        </Col>
      </Row>
      {/* submission */}
      <Row gutter={8} align="middle">
        <Col flex="auto">
          <Form.Item
            name="submission_tutorial"
            label="Submission Tutorial"
            rules={[
              { required: false },
              { message: "Input name of event, please!" },
            ]}
          >
            <Input
              placeholder="Link"
              disabled={!!props.form.getFieldValue("submission_tutorial")} // ปิดการแก้ไข Input หากมีค่าใน submission
            />
          </Form.Item>
        </Col>
        <Col>
          {props.form.getFieldValue("submission_tutorial") ? ( // ถ้ามีค่าใน submission
            <Tooltip placement="bottom" title="Clear Path">
              <Button
                onClick={() => {
                  props.form.setFieldsValue({ submission: null });
                  forceUpdate({});
                }}
                icon={"X"}
                danger
              ></Button>
            </Tooltip>
          ) : (
            <Tooltip placement="bottom" title="Upload">
              <Upload
                beforeUpload={(file) => validateFileSize(file, 300)}
                maxCount={1}
                showUploadList={false}
                onChange={async (info) => {
                  if (info.fileList.length > 0) {
                    const file = info.fileList[0].originFileObj;
                    const fileName = info.fileList[0].name;
                    try {
                      setUploadingsubmit(true);
                      const task_id = props.form.getFieldValue("task_id");
                      if (!task_id) {
                        message.error("Codename is not set");
                        return;
                      }

                      // อัปโหลดไฟล์ไปยัง API
                      const response = await upload_file({
                        task_id: task_id,
                        type: "submission_tutorial",
                        name: fileName,
                        file: file,
                      });

                      if (response.status === "success") {
                        props.form.setFieldsValue({
                          submission_tutorial: response.link,
                        });
                        forceUpdate({});
                      } else {
                        console.error("File upload failed:", response);
                      }
                    } catch (error) {
                      console.error("Error uploading file:", error);
                    } finally {
                      setUploadingsubmit(false); // หยุดแสดง Loading เมื่อเสร็จสิ้น
                    }
                  }
                }}
              >
                <Button
                  style={{
                    backgroundColor: "#0E21A0",
                    color: "white",
                  }}
                  icon={!uploadingsubmit && <UploadOutlined />}
                  loading={uploadingsubmit}
                >
                  {uploadingsubmit ? "Uploading..." : ""}
                </Button>
              </Upload>
            </Tooltip>
          )}
        </Col>
      </Row>
      {/* Public Evaluation */}
      <Row gutter={8} align="middle">
        <Col xs={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <Form.Item
                name="evaluationPublic"
                label="Evaluation script (Public)"
                rules={[
                  { required: false },
                  { message: "Input name of event, please!" },
                ]}
              >
                <Input
                  placeholder="Link"
                  disabled={!!props.form.getFieldValue("evaluationPublic")} // ปิดการแก้ไข Input หากฟิลด์ evaluationPublic มีค่า
                />
              </Form.Item>
            </Col>
            <Col>
              {props.form.getFieldValue("evaluationPublic") ? (
                <Tooltip placement="bottom" title="Clear Path">
                  <Button
                    onClick={() => {
                      // ลบค่าของ evaluationPublic
                      props.form.setFieldsValue({
                        evaluationPublic: null,
                      });
                      forceUpdate({}); // บังคับอัปเดต
                    }}
                    icon={"X"}
                    danger
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip placement="bottom" title="Upload">
                  <Upload
                    beforeUpload={(file) => validateFileSize(file, 300)}
                    maxCount={1}
                    showUploadList={false}
                    onChange={async (info) => {
                      if (info.fileList.length > 0) {
                        const file = info.fileList[0].originFileObj;
                        const fileName = info.fileList[0].name;

                        try {
                          setUploadingevapub(true);
                          const task_id = props.form.getFieldValue("task_id");
                          if (!task_id) {
                            message.error("Codename is not set");
                            return;
                          }

                          const response = await upload_file({
                            task_id: task_id,
                            type: "evaluation_script_public",
                            name: fileName,
                            file: file,
                          });

                          if (response.status === "success") {
                            props.form.setFieldsValue({
                              evaluationPublic: response.link,
                            });
                            forceUpdate({}); // บังคับอัปเดต
                          } else {
                            console.error("File upload failed:", response);
                          }
                        } catch (error) {
                          console.error("Error uploading file:", error);
                        } finally {
                          setUploadingevapub(false); // หยุดแสดง Loading เมื่อเสร็จสิ้น
                        }
                      }
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#0E21A0",
                        color: "white",
                      }}
                      icon={!uploadingevapub && <UploadOutlined />}
                      loading={uploadingevapub}
                    >
                      {uploadingevapub ? "Uploading..." : ""}
                    </Button>
                  </Upload>
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>

        {/* Evaluation script (Private) */}
        <Col xs={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <Form.Item
                name="evaluationprivate"
                label="Evaluation script (Private)"
                rules={[
                  { required: false },
                  { message: "Input name of event, please!" },
                ]}
              >
                <Input
                  placeholder="Link"
                  disabled={!!props.form.getFieldValue("evaluationprivate")}
                />
              </Form.Item>
            </Col>
            <Col>
              {props.form.getFieldValue("evaluationprivate") ? (
                <Tooltip placement="bottom" title="Clear Path">
                  <Button
                    onClick={() => {
                      // ลบค่าของ evaluationprivate
                      props.form.setFieldsValue({
                        evaluationprivate: null,
                      });
                      forceUpdate({}); // บังคับอัปเดต
                    }}
                    icon={"X"}
                    danger
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip placement="bottom" title="Upload">
                  <Upload
                    beforeUpload={(file) => validateFileSize(file, 300)}
                    maxCount={1}
                    showUploadList={false}
                    onChange={async (info) => {
                      if (info.fileList.length > 0) {
                        const file = info.fileList[0].originFileObj;
                        const fileName = info.fileList[0].name;

                        try {
                          setUploadingevaprivate(true);
                          const task_id = props.form.getFieldValue("task_id");
                          if (!task_id) {
                            message.error("Codename is not set");
                            return;
                          }

                          const response = await upload_file({
                            task_id: task_id,
                            type: "evaluation_script_private",
                            name: fileName,
                            file: file,
                          });

                          if (response.status === "success") {
                            props.form.setFieldsValue({
                              evaluationprivate: response.link,
                            });
                            forceUpdate({}); // บังคับอัปเดต
                          } else {
                            console.error("File upload failed:", response);
                          }
                        } catch (error) {
                          console.error("Error uploading file:", error);
                        } finally {
                          setUploadingevaprivate(false); // หยุดแสดง Loading เมื่อเสร็จสิ้น
                        }
                      }
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#0E21A0",
                        color: "white",
                      }}
                      icon={!uploadingevaprivate && <UploadOutlined />}
                      loading={uploadingevaprivate}
                    >
                      {uploadingevaprivate ? "Uploading..." : ""}
                    </Button>
                  </Upload>
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      {/* datasheet */}
      <Row gutter={8} align="middle">
        <Col xs={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <Form.Item
                name="datasheet"
                label="Data sheet"
                rules={[
                  { required: false },
                  {
                    message: "Input name of datasheet, please!",
                  },
                ]}
              >
                <Input
                  placeholder="Link"
                  disabled={!!props.form.getFieldValue("datasheet")} // ปิดการแก้ไข Input หากฟิลด์ evaluationPublic มีค่า
                  // ที่ต้องเปลี่ยน evaluationPublic
                />
              </Form.Item>
            </Col>
            <Col>
              {props.form.getFieldValue("datasheet") ? (
                <Tooltip placement="bottom" title="Clear Path">
                  <Button
                    onClick={() => {
                      // ลบค่าของ evaluationPublic
                      props.form.setFieldsValue({
                        datasheet: null,
                      });
                      forceUpdate({}); // บังคับอัปเดต
                    }}
                    icon={"X"}
                    danger
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip placement="bottom" title="Upload">
                  <Upload
                    beforeUpload={(file) => validateFileSize(file, 300)}
                    maxCount={1}
                    showUploadList={false}
                    onChange={async (info) => {
                      if (info.fileList.length > 0) {
                        const file = info.fileList[0].originFileObj;
                        const fileName = info.fileList[0].name;

                        try {
                          setUploadingsheet(true);
                          const task_id = props.form.getFieldValue("task_id");
                          if (!task_id) {
                            message.error("Codename is not set");
                            return;
                          }

                          const response = await upload_file({
                            task_id: task_id,
                            type: "datasheet",
                            name: fileName,
                            file: file,
                          });

                          if (response.status === "success") {
                            props.form.setFieldsValue({
                              datasheet: response.link,
                            });
                            forceUpdate({}); // บังคับอัปเดต
                          } else {
                            console.error("File upload failed:", response);
                          }
                        } catch (error) {
                          console.error("Error uploading file:", error);
                        } finally {
                          setUploadingsheet(false); // หยุดแสดง Loading เมื่อเสร็จสิ้น
                        }
                      }
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#0E21A0",
                        color: "white",
                      }}
                      icon={!uploadingsheet && <UploadOutlined />}
                      loading={uploadingsheet}
                    >
                      {uploadingsheet ? "Uploading..." : ""}
                    </Button>
                  </Upload>
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>
        {/* paper */}
        <Col xs={24} md={12}>
          <Row gutter={8} align="middle">
            <Col flex="auto">
              <Form.Item
                name="paper"
                label="Paper"
                rules={[
                  { required: false },
                  { message: "Input name of paper, please!" },
                ]}
              >
                <Input
                  placeholder="Link"
                  disabled={!!props.form.getFieldValue("paper")}
                />
              </Form.Item>
            </Col>
            <Col>
              {props.form.getFieldValue("paper") ? (
                <Tooltip placement="bottom" title="Clear Path">
                  <Button
                    onClick={() => {
                      props.form.setFieldsValue({
                        paper: null,
                      });
                      forceUpdate({}); // บังคับอัปเดต
                    }}
                    icon={"X"}
                    danger
                  ></Button>
                </Tooltip>
              ) : (
                <Tooltip placement="bottom" title="Upload">
                  <Upload
                    beforeUpload={(file) => validateFileSize(file, 300)}
                    maxCount={1}
                    showUploadList={false}
                    onChange={async (info) => {
                      if (info.fileList.length > 0) {
                        const file = info.fileList[0].originFileObj;
                        const fileName = info.fileList[0].name;

                        try {
                          setUploadingpaper(true);
                          const task_id = props.form.getFieldValue("task_id");
                          if (!task_id) {
                            message.error("Codename is not set");
                            return;
                          }

                          const response = await upload_file({
                            task_id: task_id,
                            type: "paper",
                            name: fileName,
                            file: file,
                          });

                          if (response.status === "success") {
                            props.form.setFieldsValue({
                              paper: response.link,
                            });
                            forceUpdate({}); // บังคับอัปเดต
                          } else {
                            console.error("File upload failed:", response);
                          }
                        } catch (error) {
                          console.error("Error uploading file:", error);
                        } finally {
                          setUploadingpaper(false); // หยุดแสดง Loading เมื่อเสร็จสิ้น
                        }
                      }
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#0E21A0",
                        color: "white",
                      }}
                      icon={!uploadingpaper && <UploadOutlined />}
                      loading={uploadingpaper}
                    >
                      {uploadingpaper ? "Uploading..." : ""}
                    </Button>
                  </Upload>
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Submission Type */}
      {/* <Row gutter={8} align="middle">
        <Col xs={12}>
          <Form.Item
            name="submissiontype"
            label={t("Submission Type")}
            rules={[
              {
                required: false,
                message: "Please select a submission type!",
              },
            ]}
          >
            <Select
              placeholder="Please Select type"
              defaultValue={1}
              // value={submittypeSelect}
              // onChange={(value) => {
              //   // handleChageType(value);
              //   props.form.setFieldsValue({
              //     submissiontype: value,
              //   });
              //   setSubmitTypeSelect(value);
              // }}
              options={[
                {
                  value: 2,
                  label: "Result File Submission",
                },
                { value: 1, label: "Model Submission" },
              ]}
            />
          </Form.Item>
        </Col>
        <Form.Item noStyle shouldUpdate={(prev, cur) => prev.submissiontype !== cur.submissiontype}>
          {({ getFieldValue }) =>
            getFieldValue("submissiontype") === 2 ? (
              <>
                <Col xs={9}>
                  <Form.Item
                    name="submission_file_name"
                    label={t("Submission File Name")}
                    rules={[
                      {
                        required: true,
                        message: "Please input submission file name!",
                      },
                    ]}
                  >
                    <Input placeholder="e.g. submission" />
                  </Form.Item>
                </Col>
                <Col xs={3}>
                  <Form.Item
                    name="submission_file_type"
                    label={t("File Type")}
                    rules={[
                      {
                        required: true,
                        message: "Please input file type!",
                      },
                    ]}
                  >
                    <Input placeholder="e.g. csv" />
                  </Form.Item>
                </Col>
              </>
            ) : null
          }
        </Form.Item>
      </Row> */}

      {/* ================ */}
      {/* <Row gutter={8} align="middle">
        <Col xs={24} md={12}>
          <Form.Item
            name="submissiontype"
            label={t("Submission Type")}
            rules={[
              {
                required: false,
                message: "Please select a submission type!",
              },
            ]}
          >
            <Select
              placeholder="Please Select type"
              defaultValue={1}
              // value={submittypeSelect}
              // onChange={(value) => {
              //   // handleChageType(value);
              //   props.form.setFieldsValue({
              //     submissiontype: value,
              //   });
              //   setSubmitTypeSelect(value);
              // }}
              options={[
                {
                  value: 2,
                  label: "Result File Submission",
                },
                { value: 1, label: "Model Submission" },
              ]}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name="submissiontypedate"
            label={"Submission Limit Type"}
            rules={[
              {
                required: false,
                message: "Please select a submission date!",
              },
            ]}
          >
            <Select
              placeholder="Please Select type"
              defaultValue={1}
              options={[
                { value: 1, label: "ครั้ง/วัน" },
                {
                  value: 2,
                  label: "ครั้ง/สัปดาห์",
                },
                {
                  value: 3,
                  label: "ครั้ง/เดือน",
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row> */}

      <Row gutter={16}>
        <Col xs={24} md={submission_typedate == 0 ? 24 : 12}>
          <Space.Compact block>
            <Form.Item
              name="submission_limit"
              style={{ width: "80%" }}
              label={t("Submission limit")}
              rules={[
                {
                  required: false,
                  message: "Please input submission limit!",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                max={100}
                min={1}
                // addonAfter={
                //   submission_type === 2 ? t("Times / Day") : t("Times / Person")
                // }

                // addonAfter={
                //   submittypeSelect === "2"
                //     ? t("Times / Day")
                //     : t("Times / Person")
                // }
                placeholder={
                  submission_type === 2
                    ? "อัพโหลดไฟล์ได้จำนวนครั้งต่อวัน"
                    : "อัพโหลดจำนวนครั้งต่อคน"
                }
                // placeholder={
                //   submittypeSelect === "2"
                //     ? "อัพโหลดไฟล์ได้จำนวนครั้งต่อวัน"
                //     : "อัพโหลดจำนวนครั้งต่อคน"
                // }
                onKeyPress={handleNumberInput}
              />
            </Form.Item>
            <Form.Item
              name="submissiontypedate"
              label={" "}
              style={{ width: "20%" }}
              rules={[
                {
                  required: false,
                  message: "Please select a submission date!",
                },
              ]}
            >
              <Select
                placeholder="Please Select type"
                defaultValue={1}
                options={[
                  { value: 0, label: "ครั้ง/กิจกรรม" },
                  { value: 1, label: "ครั้ง/วัน" },
                  {
                    value: 2,
                    label: "ครั้ง/สัปดาห์",
                  },
                  {
                    value: 3,
                    label: "ครั้ง/เดือน",
                  },
                ]}
              />
            </Form.Item>
          </Space.Compact>
        </Col>
        <Col xs={24} md={12}>
          {submission_typedate == 0 ? null : submission_typedate == 2 ? (
            <Space.Compact block>
              <Form.Item
                style={{ width: "60%" }}
                name="day_start_task"
                label={t("Submission Time")}
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกค่าเริ่มต้นงาน",
                  },
                  // {
                  //   pattern: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // Ensure proper HH:mm format
                  //   message: "กรุณากรอกเวลาในรูปแบบ hh:mm:ss เช่น 14:30:00",
                  // },
                  // {
                  //   pattern: /^\d{2}:\d{2}:\d{2}$/, // ตรวจสอบว่าไม่มีตัวอักษร
                  //   message: "กรุณาใช้เฉพาะตัวเลขและเครื่องหมาย : เท่านั้น",
                  // },
                ]}
              >
                <Radio.Group
                  style={{ width: "100%" }}
                  defaultValue={0}
                  options={[
                    {
                      value: 0,
                      label: "Sun",
                    },
                    {
                      value: 1,
                      label: "Mon",
                    },
                    {
                      value: 2,
                      label: "Tue",
                    },
                    {
                      value: 3,
                      label: "Wed",
                    },
                    {
                      value: 4,
                      label: "Thurs",
                    },
                    {
                      value: 5,
                      label: "Fri",
                    },
                    {
                      value: 6,
                      label: "Sat",
                    },
                  ]}
                />
              </Form.Item>
              <Form.Item
                style={{ width: "40%" }}
                name="time_start_task"
                label={" "}
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกค่าเริ่มต้นงาน",
                  },
                  {
                    pattern: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // Ensure proper HH:mm format
                    message: "กรุณากรอกเวลาในรูปแบบ hh:mm:ss เช่น 14:30:00",
                  },
                  {
                    pattern: /^\d{2}:\d{2}:\d{2}$/, // ตรวจสอบว่าไม่มีตัวอักษร
                    message: "กรุณาใช้เฉพาะตัวเลขและเครื่องหมาย : เท่านั้น",
                  },
                ]}
              >
                {/* <Row gutter={16}> */}
                {/* <Col xs={12}>
                <DatePicker style={{ width: "100%" }} />
              </Col> */}
                {/* <Col xs={12}> */}
                <Input
                  placeholder="กรุณากรอกเวลา (HH:mm:ss)"
                  onChange={(e) =>
                    handleTimeChange(e, (value: any) =>
                      props.form.setFieldsValue({
                        time_start_task: value,
                      }),
                    )
                  }
                />
                {/* </Col>
            </Row> */}
              </Form.Item>
            </Space.Compact>
          ) : submission_typedate == 3 ? (
            <Space.Compact block>
              <Form.Item
                style={{ width: "50%" }}
                name="date_start_task"
                label={t("Submission Time")}
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกค่าเริ่มต้นงาน",
                  },
                ]}
              >
                {/* <Row gutter={16}>
              <Col xs={12}> */}
                <DatePicker style={{ width: "100%" }} format={"DD-MM-YYYY"} />
                {/* </Col>
              <Col xs={12}> */}
                {/* <Input
              placeholder="กรุณากรอกเวลา (HH:mm:ss)"
              onChange={(e) =>
                handleTimeChange(e, (value: any) =>
                  props.form.setFieldsValue({
                    time_start_task: value,
                  })
                )
              }
            /> */}
                {/* </Col>
            </Row> */}
              </Form.Item>
              <Form.Item
                style={{ width: "50%" }}
                name="time_start_task"
                label={" "}
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกค่าเริ่มต้นงาน",
                  },
                  {
                    pattern: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // Ensure proper HH:mm format
                    message: "กรุณากรอกเวลาในรูปแบบ hh:mm:ss เช่น 14:30:00",
                  },
                  {
                    pattern: /^\d{2}:\d{2}:\d{2}$/, // ตรวจสอบว่าไม่มีตัวอักษร
                    message: "กรุณาใช้เฉพาะตัวเลขและเครื่องหมาย : เท่านั้น",
                  },
                ]}
              >
                {/* <Row gutter={16}> */}
                {/* <Col xs={12}>
                <DatePicker style={{ width: "100%" }} />
              </Col> */}
                {/* <Col xs={12}> */}
                <Input
                  placeholder="กรุณากรอกเวลา (HH:mm:ss)"
                  onChange={(e) =>
                    handleTimeChange(e, (value: any) =>
                      props.form.setFieldsValue({
                        time_start_task: value,
                      }),
                    )
                  }
                />
                {/* </Col>
            </Row> */}
              </Form.Item>
            </Space.Compact>
          ) : (
            <Space.Compact block>
              <Form.Item
                style={{ width: "100%" }}
                name="time_start_task"
                label={t("Submission Time")}
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกค่าเริ่มต้นงาน",
                  },
                  {
                    pattern: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // Ensure proper HH:mm format
                    message: "กรุณากรอกเวลาในรูปแบบ hh:mm:ss เช่น 14:30:00",
                  },
                  {
                    pattern: /^\d{2}:\d{2}:\d{2}$/, // ตรวจสอบว่าไม่มีตัวอักษร
                    message: "กรุณาใช้เฉพาะตัวเลขและเครื่องหมาย : เท่านั้น",
                  },
                ]}
              >
                {/* <Row gutter={16}> */}
                {/* <Col xs={12}>
                <DatePicker style={{ width: "100%" }} />
              </Col> */}
                {/* <Col xs={12}> */}
                <Input
                  placeholder="กรุณากรอกเวลา (HH:mm:ss)"
                  onChange={(e) =>
                    handleTimeChange(e, (value: any) =>
                      props.form.setFieldsValue({
                        time_start_task: value,
                      }),
                    )
                  }
                />
                {/* </Col>
            </Row> */}
              </Form.Item>
            </Space.Compact>
          )}
        </Col>
      </Row>
      {/* <Row gutter={16}> */}
      {/* Submission Limit */}
      {/* <Col xs={24} md={12}>
          <Form.Item
            name="submission_limit"
            label={t("Submission limit")}
            rules={[
              {
                required: false,
                message: "Please input submission limit!",
              },
            ]}
          >
            <InputNumber
              style={{ width: "100%" }}
              max={100}
              min={1}
              // addonAfter={
              //   submission_type === 2 ? t("Times / Day") : t("Times / Person")
              // }
              addonAfter={
                <Row
                  style={{ width: "150px" }}
                  align={"middle"}
                  justify={"center"}
                >
                  <Col xs={20}>
                    <Form.Item
                      name="submissiontypedate"
                      // label={"Submission Limit Type"}
                      rules={[
                        {
                          required: false,
                          message: "Please select a submission date!",
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Please Select type"
                        defaultValue={1}
                        options={[
                          { value: 1, label: "ครั้ง/วัน" },
                          {
                            value: 2,
                            label: "ครั้ง/สัปดาห์",
                          },
                          {
                            value: 3,
                            label: "ครั้ง/เดือน",
                          },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                // submission_type === 2 ? t("Times / Day") : t("Times / Person")
              }
              // addonAfter={
              //   submittypeSelect === "2"
              //     ? t("Times / Day")
              //     : t("Times / Person")
              // }
              placeholder={
                submission_type === 2
                  ? "อัพโหลดไฟล์ได้จำนวนครั้งต่อวัน"
                  : "อัพโหลดจำนวนครั้งต่อคน"
              }
              // placeholder={
              //   submittypeSelect === "2"
              //     ? "อัพโหลดไฟล์ได้จำนวนครั้งต่อวัน"
              //     : "อัพโหลดจำนวนครั้งต่อคน"
              // }
              onKeyPress={handleNumberInput}
            />
          </Form.Item>
        </Col> */}
      {/* Submission time */}
      {/* <Col xs={24} md={12}>
          <Form.Item
            name="time_start_task"
            label={t("Submission Time")}
            rules={[
              {
                required: false,
                message: "กรุณากรอกค่าเริ่มต้นงาน",
              },
              {
                pattern: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/, // Ensure proper HH:mm format
                message: "กรุณากรอกเวลาในรูปแบบ hh:mm:ss เช่น 14:30:00",
              },
              {
                pattern: /^\d{2}:\d{2}:\d{2}$/, // ตรวจสอบว่าไม่มีตัวอักษร
                message: "กรุณาใช้เฉพาะตัวเลขและเครื่องหมาย : เท่านั้น",
              },
            ]}
          >
            <Row gutter={16}>
              <Col xs={12}>
                <DatePicker style={{ width: "100%" }} />
              </Col>
              <Col xs={12}>
                <Input
                  placeholder="กรุณากรอกเวลา (HH:mm:ss)"
                  onChange={(e) =>
                    handleTimeChange(e, (value: any) =>
                      props.form.setFieldsValue({
                        time_start_task: value,
                      })
                    )
                  }
                />
              </Col>
            </Row>
          </Form.Item>
        </Col> */}
      {/* </Row> */}

      {/* metric */}
      <Card
        title={t("Metric")}
        style={{
          width: "100%",
          backgroundColor: "#F3F3F1",
          borderColor: "#cccccc",
        }}
      >
        <Form.Item
          name="metrics"
          rules={[
            {
              required: false,
              message: "Please add at least one metric!",
            },
          ]}
        >
          {hasMetrics && (
            <Row
              gutter={8}
              align="middle"
              style={{ fontWeight: "bold", marginBottom: 5 }}
            >
              <Col span={1}></Col>
              <Col xs={11} md={7} lg={7} xl={7}>
                <span style={{ fontSize: 15 }}>{t("Metric")}</span>
              </Col>
              <Col xs={12} md={7} lg={7} xl={7}>
                <span style={{ fontSize: 15 }}>{t("Display Name")}</span>
              </Col>
              <Col xs={12} md={4} lg={4} xl={4}>
                <span style={{ fontSize: 15 }}>{t("Order")}</span>
              </Col>
              <Col xs={9} md={3} lg={3} xl={3} offset={1}>
                <span style={{ fontSize: 15 }}>{t("Default")}</span>
              </Col>
            </Row>
          )}

          <Form.List name="metrics">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <Form.Item key={field.key} required={false}>
                    <Row gutter={8} align="middle">
                      <Col span={1}>
                        <span>{index + 1}.</span>
                      </Col>
                      <Col xs={11} md={7} lg={7} xl={7}>
                        <Form.Item
                          {...field}
                          name={[field.name, "name"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const description = getFieldValue([
                                  "metrics",
                                  field.name,
                                  "description",
                                ]);
                                if (!value && description) {
                                  return Promise.reject(
                                    "Please input a metric name!",
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                            {
                              validator: (_, value) =>
                                value && value.trim() !== ""
                                  ? Promise.resolve()
                                  : Promise.reject(
                                      new Error("กรุณากรอกข้อมูล"),
                                    ),
                            },
                          ]}
                          noStyle
                          normalize={(value) => value?.trimStart() || ""}
                        >
                          <Input
                            placeholder="Metric"
                            onChange={() => {
                              props.form.validateFields([
                                ["metrics", field.name, "description"],
                              ]); // ✅ Trigger Validation ของ description
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={12} md={7} lg={7} xl={7}>
                        <Form.Item
                          {...field}
                          name={[field.name, "description"]}
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                const name = getFieldValue([
                                  "metrics",
                                  field.name,
                                  "name",
                                ]);
                                if (!value && name) {
                                  return Promise.reject(
                                    "Please input a metric description!",
                                  );
                                }
                                return Promise.resolve();
                              },
                            }),
                            {
                              validator: (_, value) =>
                                value && value.trim() !== ""
                                  ? Promise.resolve()
                                  : Promise.reject(
                                      new Error("กรุณากรอกข้อมูล"),
                                    ),
                            },
                          ]}
                          noStyle
                          normalize={(value) => value?.trimStart() || ""}
                        >
                          <Input
                            placeholder="Description"
                            onChange={() => {
                              props.form.validateFields([
                                ["metrics", field.name, "name"],
                              ]); // ✅ Trigger Validation ของ name
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={12} md={4} lg={4} xl={4}>
                        {/*  span={4} */}
                        <Form.Item
                          {...field}
                          name={[field.name, "order"]}
                          noStyle
                        >
                          <Select placeholder="Sort Order">
                            <Select.Option value="desc">
                              {t("More to less")}
                            </Select.Option>
                            <Select.Option value="asc">
                              {t("Too little")}
                            </Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={9} md={3} lg={3} xl={3} offset={1}>
                        {/*  span={3} */}
                        <Form.Item
                          {...field}
                          name={[field.name, "default"]}
                          valuePropName="checked"
                          noStyle
                        >
                          <Radio.Group
                            value={
                              mainMetricIndex ===
                              props.form.getFieldValue([
                                "metrics",
                                field.name,
                                "name",
                              ])
                                ? "main"
                                : null
                            }
                            onChange={() => {
                              const selectedMetric = props.form.getFieldValue([
                                "metrics",
                                field.name,
                                "name",
                              ]);
                              setMainMetricIndex(selectedMetric); // ✅ อัปเดต metric ที่ถูกเลือกให้เป็น main

                              // ✅ อัปเดตค่า default ในฟอร์ม
                              props.form.setFieldsValue({
                                metrics: fields.map((f) => ({
                                  ...props.form.getFieldValue([
                                    "metrics",
                                    f.name,
                                  ]),
                                  default:
                                    props.form.getFieldValue([
                                      "metrics",
                                      f.name,
                                      "name",
                                    ]) === selectedMetric,
                                })),
                              });
                            }}
                          >
                            <Radio.Group
                              value={
                                props.form.getFieldValue([
                                  "metrics",
                                  field.name,
                                  "default",
                                ])
                                  ? "main"
                                  : null
                              }
                              onChange={() => {
                                // ตั้ง metric นี้เป็น default
                                const currentMetrics =
                                  props.form.getFieldValue("metrics");
                                const updatedMetrics = currentMetrics.map(
                                  (metric: any, idx: number) => ({
                                    ...metric,
                                    default: idx === index, // กำหนด default สำหรับ metric ที่เลือก
                                  }),
                                );
                                props.form.setFieldsValue({
                                  metrics: updatedMetrics,
                                });
                              }}
                            >
                              <Radio value="main"></Radio>
                              {/* ตัววัดผลหลัก */}
                            </Radio.Group>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col>
                        <Popconfirm
                          title={t("Are you sure you want to delete this item")}
                          description={t("This information will be deleted")}
                          okText={t("confirm")}
                          cancelText={t("cancel")}
                          onConfirm={() => {
                            const currentMetrics =
                              props.form.getFieldValue("metrics");
                            if (currentMetrics[index]?.default) {
                              remove(field.name);
                              const updatedMetrics =
                                props.form.getFieldValue("metrics");

                              if (updatedMetrics.length > 0) {
                                updatedMetrics[0].default = true;
                              }

                              props.form.setFieldsValue({
                                metrics: updatedMetrics,
                              });
                            } else {
                              remove(field.name);
                            }
                            if (fields.length === 1) setHasMetrics(false);
                          }}
                        >
                          <Tooltip placement="bottom" title="Delete">
                            <Button
                              style={{
                                backgroundColor: "#B31312",
                                color: "white",
                              }}
                              icon={<DeleteOutlined />}
                            />
                          </Tooltip>
                        </Popconfirm>
                      </Col>
                    </Row>
                  </Form.Item>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => {
                      add({
                        name: "",
                        default:
                          props.form.getFieldValue("metrics") == undefined ||
                          props.form.getFieldValue("metrics").length == 0
                            ? true
                            : false,
                        // default: false,
                        order: "desc",
                      });
                      setHasMetrics(true);
                    }}
                    icon={<PlusOutlined />}
                    style={{ width: "100%" }}
                  >
                    {t("Add Metric")}
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form.Item>
      </Card>

      {/* modal guideline */}
      {/* Modal */}
      <Modal
        title={t("Using the Docker Registry")}
        open={isModalOpen}
        onOk={() => setIsModalOpen(false)}
        onCancel={() => setIsModalOpen(false)}
        width={1000}
        footer={[
          <Button key="back" onClick={() => setIsModalOpen(false)}>
            {t("cancel")}
          </Button>,
        ]}
        bodyStyle={{
          maxHeight: "60vh",
          overflowY: "auto",
        }}
      >
        <div>
          <Title level={4}>{t("Login")}</Title>
          <ul className="b">
            <li style={{ userSelect: "text" }}>{t("Dictation")}</li>
          </ul>
          <Card className="code-block" bodyStyle={{ padding: 0 }}>
            <Row align={"middle"} justify={"space-between"}>
              <Col>
                <span className="talk-code">{tutorial.login}</span>
              </Col>
              <Col style={{ marginLeft: "auto" }}>
                <Button
                  // type="text"
                  type="default"
                  icon={<CopyOutlined />}
                  onClick={() => {
                    navigator.clipboard.writeText(tutorial.login);
                    message.success("Copied to clipboard!");
                  }}
                  style={{ marginLeft: "auto" }}
                />
              </Col>
            </Row>
          </Card>
          <div className="exam-desciption">
            <span style={{ fontSize: "16px", userSelect: "text" }}>
              {t("Then enter the usercode")} ({userData.user_code}){" "}
              {t("and user password")}
            </span>
          </div>
        </div>
        {/* Push Image */}
        <div>
          <Title level={4} className="top-head">
            {t("Push Image")}
          </Title>
          <ul className="b">
            <li style={{ userSelect: "text" }}>
              {t(
                "Create the desired image by building or tagging it with the registry name in front",
              )}
            </li>
          </ul>
          <Card className="code-block" bodyStyle={{ padding: 0 }}>
            <Row align={"middle"} justify={"space-between"}>
              <Col>
                <span className="talk-code">{tutorial.image_tag}</span>
              </Col>
              <Col>
                <Button
                  type="default"
                  icon={<CopyOutlined />}
                  onClick={() => {
                    navigator.clipboard.writeText(tutorial.image_tag);
                    message.success("Copied to clipboard!");
                  }}
                />
              </Col>
            </Row>
          </Card>
          <div className="exam-desciption">
            <ul className="b">
              <li style={{ userSelect: "text" }}>
                {t("Push image into docker registry")}
              </li>
            </ul>
          </div>
          <Card className="code-block" bodyStyle={{ padding: 0 }}>
            <Row align={"middle"} justify={"space-between"}>
              <Col>
                <span className="talk-code">{tutorial.image_push}</span>
              </Col>
              <Col>
                <Button
                  type="default"
                  icon={<CopyOutlined />}
                  onClick={() => {
                    navigator.clipboard.writeText(tutorial.image_push);
                    message.success("Copied to clipboard!");
                  }}
                />
              </Col>
            </Row>
          </Card>
        </div>
        {/* การ logout */}
        <div>
          <Title level={4} className="top-head">
            {t("Logout")}
          </Title>
          <ul className="b">
            <li>{t("Dictation")}</li>
          </ul>
          <Card className="code-block" bodyStyle={{ padding: 0 }}>
            <Row align={"middle"} justify={"space-between"}>
              <Col>
                <span className="talk-code">{tutorial.logout}</span>
              </Col>
              <Col>
                <Button
                  type="default"
                  icon={<CopyOutlined />}
                  onClick={() => {
                    navigator.clipboard.writeText(tutorial.logout);
                    message.success("Copied to clipboard!");
                  }}
                />
              </Col>
            </Row>
          </Card>
        </div>
      </Modal>
    </div>
  );
};

export default EvaluationPage;
